module.exports = __webpack_public_path__ + "img/swift-bostergreen-gls-blanco-pop.f6c32a06.png";